import { Navigate, Route, Routes } from 'react-router-dom';
import SinglePiecePage from './pages/single-piece/singlePiece';

import { NotificationWrapper } from './components/notification';
import { PopUpWrapper } from './components/popUp';
import { AppProvider } from './context/appContext';
import { DashboardProvider } from './context/dashboardContext';
import Footer from './pageparts/footer';
import Header from './pageparts/header/header';
import ArtistsPage from './pages/artists';
import DashboardAccountManagementPage from './pages/dashboard/admin/dashboardAccountManagementPage';
import DashboardAdminAllPieces from './pages/dashboard/admin/dashboardAdminAllPieces';
import DashboardAdminArtistPage from './pages/dashboard/admin/dashboardAdminArtistPage';
import DashboardAdminCreatePiecePage from './pages/dashboard/admin/dashboardAdminCreatePiece';
import DashboardAdminPiecePage from './pages/dashboard/admin/dashboardAdminPiecePage';
import DashboardArtistsManagementPage from './pages/dashboard/admin/dashboardArtistsManagementPage';
import DashboardEditArtistProfilePage from './pages/dashboard/admin/dashboardEditArtistProfilePage';
import DashboardPayoutRequestsPage from './pages/dashboard/admin/dashboardPayOutRequests';
import DashboardPurchasesPage from './pages/dashboard/admin/dashboardPurchases';
import DashboardSingleAccountManagementPage from './pages/dashboard/admin/dashboardSingleAccountManagementPage';
import DashboardBookmarkedPiecesPage from './pages/dashboard/dashboardBookmarkedPieces';
import DashboardDownloadHistoryPage from './pages/dashboard/dashboardDownloadHistoryPage';
import DashboardInfoPiecePage from './pages/dashboard/dashboardInfoPiecePage';
import DashboardLikedPieces from './pages/dashboard/dashboardLikedPieces';
import DashboardLogoutPage from './pages/dashboard/dashboardLogout';
import DashboardMyPiecesPage from './pages/dashboard/dashboardMyPieces';
import DashboardOverviewPage from './pages/dashboard/dashboardOverviewPage';
import DashboardProfilePage from './pages/dashboard/dashboardProfilePage';
import DashboardCreatePiecePage from './pages/dashboard/edit-piece/dashboardCreatePiece';
import { DashboardEditPiecePage } from './pages/dashboard/edit-piece/dashboardEditPiece';
import DashboardSettingsPage from './pages/dashboard/settingsPage';
import DiscoverPage from './pages/discoverPage';
import ErrorPage from './pages/errorPage';
import FAQPage from './pages/faq';
import ImprintPage from './pages/legal/imprint';
import PrivacyPolicyPage from './pages/legal/privacy';
import TermsOfUsePage from './pages/legal/termsofuse';
import ChangeEmailPage from './pages/login/changeEmail';
import LoginPage from './pages/login/login';
import LoginBox from './pages/login/loginBox';
import SignUpPage from './pages/login/signup';
import { VerifyEmailPage } from './pages/login/verifyEmail';
import PiecesPage from './pages/pieces/pieces';
import SingleArtistPage from './pages/single-artist/singleArtist';
import "./style/main.css";
import ReportPiecePage from './pages/single-piece/reportPiece';
import ReportPieceSuccessPage from './pages/single-piece/reportPieceSuccess';

function TxoriaApp() {

  return <AppProvider>
    <PopUpWrapper/>
    <NotificationWrapper/>
    <Header/>
    <Routes>

      <Route path="/error/:id" element={<ErrorPage/>} />

      <Route path="/" element={<Navigate to="pieces"/>} />
      <Route path="/discover" element={<><DiscoverPage/><Footer/></>} />
      <Route path="/pieces" element={<><PiecesPage /><Footer/></>} />
      <Route path="/pieces/:id" element={<><SinglePiecePage /><Footer/></>} />
      <Route path="/pieces/:id/report" element={<><ReportPiecePage /><Footer/></>} />
      <Route path="/pieces/:id/report/success" element={<><ReportPieceSuccessPage /><Footer/></>} />
      <Route path="/pieces/:id/purchased" element={<><SinglePiecePage purchaseSuccess /><Footer/></>} />
      <Route path="/pieces/:id/cancelled" element={<><SinglePiecePage purchaseSuccess={false} /><Footer/></>} />
      <Route path="/artists" element={<><ArtistsPage /><Footer/></>} />
      <Route path="/artists/:id" element={<><SingleArtistPage /><Footer/></>} />


      <Route path="/imprint" element={<><ImprintPage/><Footer/></>} />
      <Route path="/terms" element={<><TermsOfUsePage/><Footer/></>} />
      <Route path="/privacy-policy" element={<><PrivacyPolicyPage/><Footer/></>} />
      <Route path="/faq" element={<><FAQPage/><Footer/></>} />


      <Route path="/login" element={<LoginPage/>} />
      <Route path="/login/registerSuccess" element={<LoginPage registeSuccess/>} />
      <Route path="/logout" element={<DashboardLogoutPage/>} />

      <Route path="/signup" element={<LoginBox login={false}><SignUpPage/></LoginBox>} />
      <Route path="/signup/verifyEmail/:id" element={<VerifyEmailPage/>} />
      <Route path="/signup/changeEmail/:id" element={<ChangeEmailPage/>} />

      <Route
        path="/dashboard/*"
        element={
          <DashboardProvider>
            <Routes>
                <Route path="/" element={<Navigate to="/dashboard/overview"/>} />
                
                <Route path="/mypieces" element={<DashboardMyPiecesPage/>} />
                <Route path="/mypieces/:id" element={<DashboardInfoPiecePage/>} />
                <Route path="/mypieces/:id/edit" element={<DashboardEditPiecePage/>} />
                <Route path="/mypieces/create" element={<DashboardCreatePiecePage/>} />

                <Route path="/bookmarked" element={<DashboardBookmarkedPiecesPage/>} />
                <Route path="/liked" element={<DashboardLikedPieces/>} />
                <Route path="/history" element={<DashboardDownloadHistoryPage/>} />
                <Route path="/settings" element={<DashboardSettingsPage/>} />
                <Route path="/profile" element={<DashboardProfilePage/>} />

                <Route path="/overview" element={<DashboardOverviewPage/>} />
                <Route path="/overview/purchased" element={<DashboardOverviewPage purchaseSuccess={true}/>} />
                <Route path="/overview/cancelled" element={<DashboardOverviewPage purchaseSuccess={false}/>} />

                <Route path="/admin/artists" element={<DashboardArtistsManagementPage/>} />
                <Route path="/admin/artists/create" element={<DashboardEditArtistProfilePage/>} />
                <Route path="/admin/artists/:id" element={<DashboardAdminArtistPage/>} />
                <Route path="/admin/artists/:id/profile" element={<DashboardEditArtistProfilePage/>} />

                <Route path="/admin/accounts" element={<DashboardAccountManagementPage/>} />
                <Route path="/admin/accounts/:id" element={<DashboardSingleAccountManagementPage/>} />

                <Route path="/admin/pieces" element={<DashboardAdminAllPieces/>} />
                <Route path="/admin/pieces/create" element={<DashboardAdminCreatePiecePage/>} />
                <Route path="/admin/pieces/create/:artistId" element={<DashboardCreatePiecePage/>} />
                <Route path="/admin/pieces/:id" element={<DashboardAdminPiecePage/>} />
                <Route path="/admin/payouts" element={<DashboardPayoutRequestsPage/>} />
                <Route path="/admin/purchases" element={<DashboardPurchasesPage/>} />

            </Routes>
          </DashboardProvider>
        }
      />
    </Routes>
    
  </AppProvider>;
}

export default TxoriaApp;
